import React from "react";
import { useTranslation } from "react-i18next";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonGroup,
  Button
} from "reactstrap";
import { changeLanguage, getCurrentLanguage, getSupportedLanguages } from "../i18n";

const LANG_META = {
  en: { labelKey: "languages.en", short: "EN" },
  tr: { labelKey: "languages.tr", short: "TR" },
  ar: { labelKey: "languages.ar", short: "AR" }
};

/**
 * Compact language switcher for navbar / settings.
 * variant: "dropdown" | "buttons"
 */
export default function LanguageSwitcher({ variant = "dropdown", className = "", dark = false }) {
  const { t, i18n } = useTranslation();
  const current = getCurrentLanguage();
  const langs = getSupportedLanguages();

  const select = (lang) => {
    if (lang !== current) changeLanguage(lang);
  };

  if (variant === "buttons") {
    return (
      <ButtonGroup className={className} size="sm">
        {langs.map((lang) => (
          <Button
            key={lang}
            color={current === lang ? "primary" : dark ? "secondary" : "light"}
            outline={current !== lang}
            onClick={() => select(lang)}
          >
            {LANG_META[lang].short}
          </Button>
        ))}
      </ButtonGroup>
    );
  }

  return (
    <UncontrolledDropdown className={className} nav={dark} inNavbar={dark}>
      <DropdownToggle
        caret
        color={dark ? "link" : "secondary"}
        size="sm"
        className={dark ? "nav-link text-white p-0" : ""}
        nav={dark}
      >
        <i className="ni ni-world-2 mr-1" />
        {LANG_META[current]?.short || current.toUpperCase()}
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem header>{t("languages.selectLanguage")}</DropdownItem>
        {langs.map((lang) => (
          <DropdownItem key={lang} active={current === lang} onClick={() => select(lang)}>
            {t(LANG_META[lang].labelKey)}
          </DropdownItem>
        ))}
      </DropdownMenu>
      {/* keep i18n subscription for re-render */}
      <span className="d-none">{i18n.language}</span>
    </UncontrolledDropdown>
  );
}
